import useGetApi from '../useGetApi';
import {
  RexelFileDiscoveryJob,
  PaginatedResponse,
  DiscoveryJobsQuery,
} from './types';

export const useRexelDiscoveryJobs = (query?: DiscoveryJobsQuery) => {
  return useGetApi<PaginatedResponse<RexelFileDiscoveryJob>>({
    endpoint: 'rexel/discovery-jobs',
    queryParameters: query,
    queryKey: ['rexel', 'discovery-jobs', query],
    options: {
      staleTime: 30 * 1000, // 30 seconds
      refetchInterval: 60 * 1000, // Refresh every minute
    },
  });
};

export const useRexelDiscoveryJob = (jobId: string | undefined) => {
  return useGetApi<RexelFileDiscoveryJob>({
    endpoint: `rexel/discovery-jobs/${jobId}`,
    queryKey: ['rexel', 'discovery-jobs', jobId],
    options: {
      enabled: !!jobId,
      staleTime: 30 * 1000,
      refetchInterval: 30 * 1000, // Refresh every 30 seconds for individual job
    },
  });
};
